import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@env/environment';
import { RUTA_INICIO } from './rutas-matricula';

/**
 * La renovacion solo entra si la Escuela la tiene abierta (SPEC-015, AC-11).
 *
 * **Es el primer guard del proyecto**, y existe porque apagar la tarjeta del
 * inicio no basta: `renewalModuleIsActive` en `false` dejaba de pintarla, pero
 * la direccion escrita a mano —o un enlace guardado del ciclo pasado— entraba
 * igual. Con el modulo cerrado la renovacion se hace en las oficinas de la Liga,
 * asi que llegar a la pantalla seria ofrecer un tramite que no existe.
 *
 * Devuelve un `UrlTree` al inicio y no `false`: `false` deja al navegador en la
 * direccion anterior, que al llegar desde fuera es ninguna, y la persona se
 * queda mirando una pantalla en blanco. El inicio, ademas, es donde el aviso de
 * que el tramite es presencial ya esta escrito (SPEC-004, AC-5).
 *
 * La bandera se lee en cada activacion y no se captura al arrancar: es de
 * compilacion, pero leerla aqui hace que la prueba pueda cambiarla sin recrear
 * el guard.
 */
export const renovacionActiva: CanActivateFn = () => {
  if (environment.renewalModuleIsActive) return true;
  return inject(Router).createUrlTree([`/${RUTA_INICIO}`]);
};
